import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import React, { useMemo, useCallback } from "react";

// Move static data outside component and optimize image URLs
const NEWS_ARTICLES_DATA = [
  {
    logoAlt: "The Tribune",
    logoUrl:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/The-Tribune-min-1745817447057.webp",
    date: "February 15, 2023",
    title: "MinEMI revolutionizes loan comparison in India",
    excerpt:
      "MinEMI, the new-age financial services platform, has announced its innovative approach to loan comparison that prioritizes minimum EMIs for customers.",
    readMoreLink:
      "https://www.tribuneindia.com/news/business/introducing-minemi-a-web-app-that-leverages-ai-to-optimize-emis-and-transform-financing/",
  },
  {
    logoAlt: "Business Standard",
    logoUrl:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/business-standard-1745817420630.webp",
    date: "January 28, 2023",
    title: "MinEMI secures funding to expand loan marketplace",
    excerpt:
      "MinEMI, a financial services group, has announced its latest funding round to expand its AI-driven loan marketplace across major Indian cities.",
    readMoreLink:
      "https://www.business-standard.com/content/press-releases-ani/introducing-minemi-a-web-app-that-leverages-ai-to-optimize-emis-and-transform-financing-125011701109_1.html",
  },
  {
    logoAlt: "Outlook",
    logoUrl:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/ani-news-1745817395396.webp",
    date: "December 12, 2022",
    title: "MinEMI partners with leading banks to enhance offerings",
    excerpt:
      "MinEMI ropes in top banking partners to provide customers with more comprehensive loan options and better rates.",
    readMoreLink:
      "https://www.aninews.in/news/business/introducing-minemi-a-web-app-that-leverages-ai-to-optimize-emis-and-transform-financing20250117171038/",
  },
];

export function NewsSection() {
  const navigate = useNavigate();

  const handleViewMore = useCallback(() => {
    navigate("/loanpage/personalloan", { state: { scrollToNews: true } });
  }, [navigate]);

  const newsArticles = useMemo(() => NEWS_ARTICLES_DATA, []);

  return (
    <section className="bg-white py-10 md:py-16">
      <div className="container px-4 md:px-6">
        <header className="mb-6 md:mb-8 text-center">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-gray-900 relative inline-block">
            In The News
            <span className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 h-0.5 w-16 bg-gray-300"></span>
          </h2>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {newsArticles.map((article, index) => (
            <article
              key={index}
              className="rounded-[24px] bg-white p-4 md:p-6 border border-gray-200 hover:shadow-md transition-shadow duration-200"
            >
              <div className="mb-3 h-8">
                <img
                  src={article.logoUrl}
                  alt={article.logoAlt}
                  width="100"
                  height="30"
                  loading="lazy"
                  decoding="async"
                  className="object-contain h-8 max-w-full"
                />
              </div>

              <time className="block mb-2 text-gray-500 text-xs md:text-sm">
                {article.date}
              </time>

              <p className="mb-4 text-gray-800 text-xs md:text-sm leading-relaxed">
                {article.excerpt}
              </p>

              <a
                href={article.readMoreLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium text-xs md:text-sm transition-colors duration-200"
                aria-label={`Read full article: ${article.title}`}
              >
                Read more
                <ArrowRight className="ml-1 h-3 w-3 md:h-4 md:w-4" />
              </a>
            </article>
          ))}
        </div>

        <div className="mt-6 md:mt-8 flex justify-center">
          <button
            className="rounded-full border border-[#59266D] text-[#59266D] hover:bg-[#59266D]/10 text-xs md:text-sm font-semibold py-3 px-6 transition-colors duration-200"
            type="button"
            onClick={handleViewMore}
          >
            View More
          </button>
        </div>
      </div>
    </section>
  );
}
